import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CommonNumberInput } from 'sharedComponents/inputGroup/CommonNumberInput';
import { Lead } from '../LeadGenInterface';
import { postLeadCreation } from 'store/LeadCreationState';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';

const TaxDeduction: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form
  const { control, trigger, watch, getValues } = useFormContext();

  // React Hook Form Watcher
  const incomePerMonthBeforeTaxWatcher = watch('incomePerMonthBeforeTax');

  // React Hook Form Trigger
  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { incomePerMonthBeforeTax } = getValues();

    const taxDeductionData: Lead = {
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        'Income Per Month Before Tax': parseInt(incomePerMonthBeforeTax),
        'Total Monthly Income': parseInt(incomePerMonthBeforeTax),
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: taxDeductionData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        const yearsOfIncomeStepIndex = widgetData?.stepConfig?.indexOf('YearsOfIncomeStep');

        incomePerMonthBeforeTaxWatcher >= 1800
          ? yearsOfIncomeStepIndex > -1
            ? onNext?.(yearsOfIncomeStepIndex) // 7 YearsOfIncomeStep
            : onNext?.()
          : onNext?.();
      }
    });
  };

  const backStep = () => {
    const employmentStatusStepIndex = widgetData?.stepConfig?.indexOf('EmploymentStatusStep');

    incomePerMonthBeforeTaxWatcher >= 1800
      ? employmentStatusStepIndex > -1
        ? onBack?.(employmentStatusStepIndex) // 4 EmploymentStatusStep
        : onBack?.()
      : onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.taxTxt')}</h3>
      <Grid container justifyContent={{ xs: 'left', sm: 'center' }} rowSpacing={3} columnSpacing={2}>
        <Grid item sm={6} xs={12}>
          <CommonNumberInput
            name='incomePerMonthBeforeTax'
            control={control}
            label={t('leadGen.monthlyIncome')}
            placeholder={t('leadGen.enter')}
            rules={formRequiredRules(errorMessage(t).monthlyIncomeRequired)}
            triggerValidationForField={trigger}
          />
        </Grid>
      </Grid>
    </>
  );
};

const TaxDeductionStep = React.forwardRef(TaxDeduction);

export default TaxDeductionStep;
